import { Card, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { moveNextPage, updateCreatorOnboarding } from "../../../../../store/actions/creator/creatorOnBoarding";
import UtilService from "../../../../../helper/service";
import { useHistory, useLocation } from "react-router";
import OnboardingBtn from "../../../../atoms/creator/onboardingEnterBtn";
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    fontSize: 36,
    color: '#212D40',
    fontFamily: 'Spartan-bold',
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
      marginTop: 26,
      marginBottom: -15
    },
  },
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: (props: any) => props.height < 830 ? -20 : 0
  },
  number: {
    fontSize: 100,
    fontFamily: 'Spartan-bold',
    color: '#697683'
  },
  description: {
    fontFamily: 'roboto-light',
    fontSize: 18,
    color: '#212D40',
    lineHeight: 1.25,
    paddingTop: (props: any) => props.height < 830 ? 20 : 30
  },
  card: {
    flex: 1,
    padding: (props: any) => props.height < 830 ? 20 : 30,
    borderRadius: 10,
    boxShadow: '2px 2px 2px 2px #70707050',
    '@media (max-width: 600px)': {
      width: 'calc(100% - 0px)'
    },
  },
  img: {
    height: (props: any) => props.height < 830 ? 120 : 135,
    width: 'auto'
  },
  cardDiv: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    paddingTop: (props: any) => props.height < 830 ? 20 : 36,
    '@media (max-width: 600px)': {
      flexDirection: 'column'
    },
  },
  mr40: {
    marginRight: 40,
    '@media (max-width: 600px)': {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 12
    },
  },
  ml40: {
    marginLeft: 40,
    '@media (max-width: 600px)': {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 12
    },
  }
}));

const Module1Slide4 = () => {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm1s4');
  }, []);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.module1s4.id,
      preference_name: 'MODULE1S4',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    if (Number(activepage.value) < 6) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '6',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    dispatch(moveNextPage(6))
  };

  const goBack = () => {
    dispatch(moveNextPage(4))
  };

  return (
    <div>
      <div className={classes.title}>
        Setting up measurements is easy.
      </div>

      <div className={classes.mainDiv}>
        <div className={classes.cardDiv}>
          <Card className={clsx(classes.card, classes.mr40)}>
            <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
              <div className={classes.number} style={{ position: 'absolute', left: 0 }}>1</div>
              <img className={classes.img} src={'/assets/icons/onboarding/module1-slide4-1.svg'} alt={'slide4-1'} />
            </div>
            <div className={classes.description}>Add a piece of content to measure</div>
          </Card>
          <Card className={clsx(classes.card, classes.ml40)}>
            <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
              <div className={classes.number} style={{ position: 'absolute', left: 0 }}>2</div>
              <img className={classes.img} src={'/assets/icons/onboarding/module1-slide4-2.svg'} alt={'slide4-1'} />
            </div>
            <div className={classes.description}>Invite participants via email or link</div>
          </Card>
        </div>

        <div className={classes.cardDiv}>
          <Card className={clsx(classes.card, classes.mr40)}>
            <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
              <div className={classes.number} style={{ position: 'absolute', left: 0 }}>3</div>
              <img className={classes.img} src={'/assets/icons/onboarding/module1-slide4-3.svg'} alt={'slide4-1'} />
            </div>
            <div className={classes.description}>Participants complete your experience</div>
          </Card>
          <Card className={clsx(classes.card, classes.ml40)}>
            <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
              <div className={classes.number} style={{ position: 'absolute', left: 0 }}>4</div>
              <img className={classes.img} src={'/assets/icons/onboarding/module1-slide4-4.svg'} alt={'slide4-1'} />
            </div>
            <div className={classes.description}>View results as they come in</div>
          </Card>
        </div>
      </div>

      <OnboardingBtn goNext={goNext} goBack={goBack} title={'Got It'} isRight />
    </div>
  )

};

export default Module1Slide4;